import { SiteInterface } from '../interfaces/site.interface';
import { FirebaseFCM } from '../interfaces/firebaseFCM.interface';
import { AppleCredentialsInterface } from '../interfaces/apple-credentials.interface';
import { PrometeoCredentialsInterface } from '../interfaces/prometeo-credentials.interface';
import { ConfigurationsAppsInterface } from '../interfaces/configurations-apps.interface';
import { PaywallConfig } from '../../paywall/shared/models/paywall-config/paywall-config';
import { JavascriptWall } from '../interfaces/javascript-wall.interface';
import { GigyaConfig } from '../interfaces/gigya-config.interface';
import { PermutiveCredentials } from '../interfaces/permutive-credentials.interface';

export class Site implements SiteInterface {
    id: string;
    name: string;
    active: boolean;
    nameDetail: string;
    certificateFCM: FirebaseFCM;
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    publicVapKey: string;
    appleCredentials: AppleCredentialsInterface;
    prometeoCredentials: PrometeoCredentialsInterface;
    paywallConfig?: boolean;
    updatedAt?: string;
    updatedBy?: string;
    group?: string;
    groupId?: string;
    configurationApps: ConfigurationsAppsInterface;
    paywall?: PaywallConfig;
    javascriptWall?: JavascriptWall;
    gigyaConfig?: GigyaConfig;
    features?: string[];
    permutive?: PermutiveCredentials;

    constructor(site?: SiteInterface) {
        const certificateFCM: FirebaseFCM = {
            apiKey: (site && site.certificateFCM && site.certificateFCM.apiKey) || '',
            appId: (site && site.certificateFCM && site.certificateFCM.appId) || '',
            authDomain: (site && site.certificateFCM && site.certificateFCM.authDomain) || '',
            databaseURL: (site && site.certificateFCM && site.certificateFCM.databaseURL) || '',
            messagingSenderId: (site && site.certificateFCM && site.certificateFCM.messagingSenderId) || '',
            projectId: (site && site.certificateFCM && site.certificateFCM.projectId) || '',
            storageBucket: (site && site.certificateFCM && site.certificateFCM.storageBucket) || '',
            publicVapKey: (site && site.certificateFCM && site.certificateFCM.publicVapKey) || '',
            serviceAccount: (site && site.certificateFCM && site.certificateFCM.serviceAccount) || '',
            serviceAccountApp: (site && site.certificateFCM && site.certificateFCM.serviceAccountApp) || '',
            checkIcon: (site && site.certificateFCM && site.certificateFCM.checkIcon) || false,
            icon: (site && site.certificateFCM && site.certificateFCM.icon) || '',
            urlErrorSite: site?.certificateFCM?.urlErrorSite || undefined,
        };

        const appleCredentials: AppleCredentialsInterface = {
            p12: (site && site.appleCredentials && site.appleCredentials.p12) || '',
            p8: (site && site.appleCredentials && (site.appleCredentials.p8 || site.appleCredentials.p9)) || '',
            keyId: (site && site.appleCredentials && site.appleCredentials.keyId) || '',
            teamId: (site && site.appleCredentials && site.appleCredentials.teamId) || '',
            websitePushId: (site && site.appleCredentials && site.appleCredentials.websitePushId) || '',
            webSiteName: (site && site.appleCredentials && site.appleCredentials.webSiteName) || '',
            image16: (site && site.appleCredentials && site.appleCredentials.image16) || '',
            image16x2: (site && site.appleCredentials && site.appleCredentials.image16x2) || '',
            image32: (site && site.appleCredentials && site.appleCredentials.image32) || '',
            image32x2: (site && site.appleCredentials && site.appleCredentials.image32x2) || '',
            image128: (site && site.appleCredentials && site.appleCredentials.image128) || '',
            image128x2: (site && site.appleCredentials && site.appleCredentials.image128x2) || '',
            allowedDomains: (site && site.appleCredentials && site.appleCredentials.allowedDomains) || [],
            password: (site && site.appleCredentials && site.appleCredentials.password) || '',
        };

        const prometeoCredentials: PrometeoCredentialsInterface = {
            icon1:
                (site && site.prometeoCredentials && site.prometeoCredentials.icon1) ||
                this.getDefaultIconValue('icon1'),
            icon2:
                (site && site.prometeoCredentials && site.prometeoCredentials.icon2) ||
                this.getDefaultIconValue('icon2'),
            icon3:
                (site && site.prometeoCredentials && site.prometeoCredentials.icon3) ||
                this.getDefaultIconValue('icon3'),
            icon4:
                (site && site.prometeoCredentials && site.prometeoCredentials.icon4) ||
                this.getDefaultIconValue('icon4'),
            icon5:
                (site && site.prometeoCredentials && site.prometeoCredentials.icon5) ||
                this.getDefaultIconValue('icon5'),
            icon6:
                (site && site.prometeoCredentials && site.prometeoCredentials.icon6) ||
                this.getDefaultIconValue('icon6'),
        };

        this.id = (site && site.id) || '';
        this.name = (site && site.name) || '';
        this.active = (site && site.active) || false;
        this.nameDetail = (site && site.nameDetail) || '';
        this.certificateFCM = certificateFCM;
        this.appleCredentials = appleCredentials;
        this.prometeoCredentials = prometeoCredentials;
        this.updatedAt = (site && site.updatedAt) || '';
        this.updatedBy = (site && site.updatedBy) || '';
        this.group = (site && site.group) || '';
        this.groupId = (site && site.groupId) || '';

        const configurationApps: ConfigurationsAppsInterface = {
            userApp: (site && site.configurationApps && site.configurationApps.userApp) || '',
            passwordApp: (site && site.configurationApps && site.configurationApps.passwordApp) || '',
        };
        this.configurationApps = configurationApps;

        const javascriptWall: JavascriptWall = {
            active: (site && site.javascriptWall && site.javascriptWall.active) || false,
            text: (site && site.javascriptWall && site.javascriptWall.text) || '',
        };
        this.javascriptWall = javascriptWall;

        const gigyaConfig: GigyaConfig = {
          apiKey: (site && site.gigyaConfig && site.gigyaConfig.apiKey) || '',
          userKey: (site && site.gigyaConfig && site.gigyaConfig.userKey) || '',
          secretKey: (site && site.gigyaConfig && site.gigyaConfig.secretKey) || '',
        };

        this.gigyaConfig = gigyaConfig;

        this.features = (site && site.features) || [];
        this.permutive = site?.permutive  ?? {};
    }

    private getDefaultIconValue(name: string): any {
        return { name: name, image: '', layout: '', accesstype: '', radioGroupValue: 3 };
    }
}
